var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.721,
    height: 34.721,
    viewBox: "0 0 34.721 34.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(-1313.412 1868.754)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M1339.858-1868.754a1.5,1.5,0,0,1,1.088,1.692c-.021.325,0,.652,0,1.02.572,0,1.121,0,1.67,0a5.36,5.36,0,0,1,4.187,1.883,5.02,5.02,0,0,1,1.316,3.333c.027,3.277.017,6.553.01,9.83a1.339,1.339,0,0,1-1.353,1.362,1.354,1.354,0,0,1-1.353-1.433q-.007-4.695,0-9.39a2.667,2.667,0,0,0-1.533-2.581,2.716,2.716,0,0,0-1-.267c-.629-.042-1.261-.012-1.941-.012,0,.465.017.925,0,1.382a1.347,1.347,0,0,1-2.069,1.1,1.322,1.322,0,0,1-.635-1.167c-.006-.428,0-.856,0-1.309h-6.171c0,.4,0,.807,0,1.209a1.367,1.367,0,0,1-1.344,1.477,1.368,1.368,0,0,1-1.367-1.487c0-.393,0-.787,0-1.2h-6.1c0,.413,0,.817,0,1.22a1.365,1.365,0,0,1-1.352,1.469,1.363,1.363,0,0,1-1.359-1.461c0-.4,0-.809,0-1.283a17.276,17.276,0,0,0-2.314.129,2.641,2.641,0,0,0-2.091,2.652c-.012.61,0,1.22,0,1.831q0,9.542,0,19.083a2.646,2.646,0,0,0,1.528,2.614,3.44,3.44,0,0,0,1.4.292c3.661.023,7.322.015,10.983.01a1.476,1.476,0,0,1,1.169.428,1.291,1.291,0,0,1,.281,1.415,1.313,1.313,0,0,1-1.122.862,2,2,0,0,1-.271.01c-3.74,0-7.48.008-11.22,0a5.4,5.4,0,0,1-5.167-3.674c-.129-.369-.2-.757-.3-1.137v-22.377a1.09,1.09,0,0,0,.064-.185,5.35,5.35,0,0,1,2.532-3.822,5.646,5.646,0,0,1,3.3-.81c.4.013.8,0,1.225,0,0-.371.018-.7,0-1.022a1.5,1.5,0,0,1,1.088-1.69h.542a1.5,1.5,0,0,1,1.089,1.689c-.022.333,0,.667,0,1h6.1c0-.349.018-.676,0-1a1.5,1.5,0,0,1,1.089-1.689h.542a1.5,1.5,0,0,1,1.089,1.689c-.022.333,0,.667,0,1h6.17c0-.349.019-.676,0-1a1.5,1.5,0,0,1,1.088-1.689Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M1583.276-1534.519a3.657,3.657,0,0,1-2.674-1.024q-2.12-2.049-4.222-4.117a1.322,1.322,0,0,1-.4-1.419,1.3,1.3,0,0,1,1.028-.928,1.361,1.361,0,0,1,1.29.433l2.062,2.013q1.019.995,2.038,1.988a.809.809,0,0,0,1.407-.135q3.205-4.476,6.41-8.952a1.386,1.386,0,0,1,1.62-.674,1.342,1.342,0,0,1,.785,1.942,2.536,2.536,0,0,1-.163.257q-3.283,4.586-6.569,9.171A3.388,3.388,0,0,1,1583.276-1534.519Z",
    transform: "translate(-244.668 -299.52)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M1419.6-1679.088a1.361,1.361,0,0,1,1.354,1.362,1.36,1.36,0,0,1-1.37,1.346,1.361,1.361,0,0,1-1.338-1.344A1.362,1.362,0,0,1,1419.6-1679.088Z",
    transform: "translate(-97.708 -176.78)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M1507.78-1677.745a1.361,1.361,0,0,1-1.353,1.363,1.361,1.361,0,0,1-1.354-1.361,1.361,1.361,0,0,1,1.336-1.346A1.361,1.361,0,0,1,1507.78-1677.745Z",
    transform: "translate(-178.639 -176.778)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M1593.243-1679.089a1.36,1.36,0,0,1,1.366,1.35,1.36,1.36,0,0,1-1.359,1.357,1.362,1.362,0,0,1-1.349-1.333A1.361,1.361,0,0,1,1593.243-1679.089Z",
    transform: "translate(-259.569 -176.779)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M1681.439-1677.72a1.361,1.361,0,0,1-1.376,1.34,1.362,1.362,0,0,1-1.332-1.384,1.362,1.362,0,0,1,1.359-1.323A1.36,1.36,0,0,1,1681.439-1677.72Z",
    transform: "translate(-340.498 -176.78)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M1420.948-1590.9a1.36,1.36,0,0,1-1.365,1.351,1.36,1.36,0,0,1-1.342-1.374,1.362,1.362,0,0,1,1.348-1.334A1.361,1.361,0,0,1,1420.948-1590.9Z",
    transform: "translate(-97.707 -257.71)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M1507.78-1590.917a1.361,1.361,0,0,1-1.352,1.364,1.361,1.361,0,0,1-1.355-1.361,1.361,1.361,0,0,1,1.335-1.347A1.361,1.361,0,0,1,1507.78-1590.917Z",
    transform: "translate(-178.639 -257.709)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M1593.272-1592.259a1.361,1.361,0,0,1,1.339,1.377,1.362,1.362,0,0,1-1.386,1.33,1.362,1.362,0,0,1-1.322-1.36A1.361,1.361,0,0,1,1593.272-1592.259Z",
    transform: "translate(-259.571 -257.709)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M1680.1-1589.55a1.362,1.362,0,0,1-1.37-1.347,1.361,1.361,0,0,1,1.354-1.361,1.362,1.362,0,0,1,1.353,1.33A1.362,1.362,0,0,1,1680.1-1589.55Z",
    transform: "translate(-340.501 -257.71)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M1420.951-1504.09a1.36,1.36,0,0,1-1.348,1.368,1.361,1.361,0,0,1-1.36-1.356,1.363,1.363,0,0,1,1.332-1.351A1.362,1.362,0,0,1,1420.951-1504.09Z",
    transform: "translate(-97.708 -338.639)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M1507.779-1504.07a1.362,1.362,0,0,1-1.365,1.351,1.361,1.361,0,0,1-1.342-1.374,1.361,1.361,0,0,1,1.348-1.334A1.361,1.361,0,0,1,1507.779-1504.07Z",
    transform: "translate(-178.637 -338.642)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceWhite);
export default __webpack_public_path__ + "static/media/AttendanceWhite.0d0a9123024177dc9a453f562c0b81e7.svg";
export { ForwardRef as ReactComponent };